import { render, staticRenderFns } from "./ContainerRentals.vue?vue&type=template&id=d6b9b20c"
import script from "./ContainerRentals.vue?vue&type=script&lang=js"
export * from "./ContainerRentals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports